import React, { useState } from 'react';
import { Navigate, useSearchParams, useNavigate } from 'react-router-dom';
// Ensure this path matches where your component actually is
import { AssistantChat } from '../components/signup';
import './AssistantChatSetup.css';

const AssistantChatSetup = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');
    const email = searchParams.get('email');
    // 1. Create the state container (this is the 'data' prop)
    const [chatData, setChatData] = useState({
        useCaseDescription: '',
        email: email || ''
    });

    // 2. Create the updater function (this is the 'updateData' prop)
    const handleUpdateData = (newData) => {
        // Merges new data into existing state
        setChatData(prev => ({ ...prev, ...newData }));
    };

    // 3. Create the navigation handler (this is the 'onNext' prop)
    const handleNext = () => {
        console.log("Chat finished. Data collected:", chatData);
        
        // Redirect to subscription/billing page
        // We append the token so the next page knows who the user is
        navigate(`/subscription-setup?token=${token}`);
    };

    // If no token is provided, kick them back to signup
    if (!token) {
        return <Navigate to="/signup" replace />;
    }

    return (
        <div className="agent-setup-page">
            {/* Pass all required props + the token */}
            <AssistantChat 
                data={chatData}
                updateData={handleUpdateData}
                onNext={handleNext}
            />
        </div>
    );
};

export default AssistantChatSetup;